// オペレータ画面用
export function init(accountId) {
  App.DemandCalls = App.cable.subscriptions.create(
    {
      channel: "DemandCallsChannel",
      account_id: accountId,
    },
    {
      connected: function () {
        // Called when the subscription is ready for use on the server
      },

      disconnected: function () {
        // Called when the subscription has been terminated by the server
      },

      received: function (data) {
        $(document).trigger("demand_call:update", data.demand_call);
      },
    }
  );
}
